'use client'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { InfoIcon } from 'lucide-react'

interface CardPanelProps {
  children: React.ReactNode
}

export function CardPanel({ children }: CardPanelProps) {
  return (
    <PageLayout className="flex min-h-screen max-w-6xl flex-col gap-4 px-3">
      <div className="flex-1 pb-24">{children}</div>

      <div className="fixed right-0 bottom-0 left-0 z-10 pb-4 text-center">
        <div className="mx-auto max-w-4xl px-3">
          <Panel.Wrapper className="p-3">
            <Panel.Content className="flex flex-row items-center justify-center gap-2">
              <InfoIcon className="h-4 w-4 flex-shrink-0 text-dim-foreground" />
              <Typography variant="p" className="text-center text-dim-foreground text-xs">
                HypurrFi Card is not affiliated with the HypurrFi Protocol and subject to separate terms provided by
                Issuer.
              </Typography>
            </Panel.Content>
          </Panel.Wrapper>
        </div>
      </div>
    </PageLayout>
  )
}
